import { Typography } from '@epilot/concorde-elements'
import classNames from 'classnames'
import type { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import classes from './ChoiceWrapper.module.scss'

type ChoiceWrapperProps = {
  hasError?: boolean
  errorMessage?: string
  label?: string | ReactNode
  isRequired?: boolean
  isRadio?: boolean
  className?: string
  id?: string
  helperText?: string
}

export const ChoiceWrapper = (props: PropsWithChildren<ChoiceWrapperProps>) => {
  const {
    hasError,
    label,
    isRequired,
    children,
    errorMessage,
    isRadio = false,
    className,
    helperText,
    id
  } = props

  const { t } = useTranslation()
  const showLabel = label || isRequired

  const showAsterisk = Boolean(isRequired && label)

  return (
    <fieldset
      className={classNames(
        isRadio && classes.radioContainer,
        classes.container,
        className
      )}
      id={id}
    >
      {showLabel && (
        <Typography
          as="legend"
          className={classNames(
            classes.title,
            showAsterisk && classes.required,
            !label && isRequired && classes.noMargin
          )}
          variant="secondary"
        >
          {label}
        </Typography>
      )}

      {children}

      {(hasError || errorMessage) && (
        <Typography
          className={classes.error}
          id={`${id}-errorMessage`}
          variant="error"
        >
          {errorMessage || t('Please select one of the options')}
        </Typography>
      )}
      {helperText && (
        <Typography className={classes.helperText}>{helperText}</Typography>
      )}
    </fieldset>
  )
}
